import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    language: "en"
  },
  mutations: {
    updateLanguage(state, payload) {
      state.language = payload;
    }
  },
  actions: {
    setLanguage(context, payload) {
      i18n.locale = payload;
      context.commit("updateLanguage", payload);
    }
  }
};
